import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { coursesQueryCrudStateConfig } from "../consts";

export const { fetchActionFactory: fetchQueryCoursesActionFactory } =
  makeCrudStateActionFactories(coursesQueryCrudStateConfig);
